import { createContext } from 'react';
import { HOST_URL } from 'src/routes/paths';

export const typeIDContext = createContext({
  typeID: null,
  updateTypeID: (typeID) => {},
});

export const NewFormContext = createContext({
  newForm: false,
  updateNewForm: (newForm) => {},
});

export const ModalRiseInCompetenceContext = createContext({
  showRIC: false,
  idQuestion : null,
  updateRICModal: (showRIC) => {},
  updateIdQuestion: (idQuestion) => {},
});

export const ModalSynchronizationContext = createContext({
  syncData: [],
  showSyncModal: false,
  updateSyncData: (syncData) => {},
  updateShowSyncModal: (showSyncModal) => {},
});

export const FormShareContext = createContext({
  showFormShare: false,
  reloadModalShare: false,
  updateFormShare: (showFormShare) => {},
  updateReloadModalShare: (reloadModalShare) => {},
});

export const FormShareIDContext = createContext({
  formShareID: "",
  updateFormShareID: (formShareID) => {},
});

export const SubscriptionContext = createContext({
  offreID: null,
  activePlan: false,
  abonnement: false,
  subscription: false,
  remainingTrainees: null,
  updateOffreID: (offreID) => {},
  updateActivePlan: (activePlan) => {},
  updateAbonnement: (abonnement) => {},
  updateSubscription: (subscription) => {},
  updateRemainingTrainees: (remainingTrainees) => {},
});

export const ModificationContext = createContext({
  modification: false,
  updateModification: (modification) => {},
});

export const DragEventContext = createContext({
  dragEvent: null,
  updateDagEvent: (dragEvent) => {},
});

export const ConfigContext = createContext({
  signed: null,
  signature: null,
  profileSave: false,
  documentView: false,
  documentStyle: false,
  updateSigned: (signed) => {},
  updateSignature: (signature) =>{},
  updateProfileSave: (profileSave)=>{},
  updateDocumentView: (documentView) => {},
  updateDocumentStyle: (documentStyle)=>{},
});

/* url: HOST_URL.hostUrl,
api: HOST_URL.apiBaseUrl */

/* export const UrlContext = createContext({
  url: 'http://localhost:8000',
  api: 'http://localhost:8001',
  front: 'http://localhost:3000'
}) */  

// Modifier le ligne 9 dans le fichier src/config-global.js
export const UrlContext = createContext({
  url: 'https://app.postgrad.fr',
  api: 'https://api.postgrad.fr',
  front: 'https://app.postgrad.fr'
});  
 
/* export const UrlContext = createContext({
  url: 'https://test.postgrad.fr',
  api: 'https://testapi.postgrad.fr',
  front: 'https://testquiz.postgrad.fr'
});   */
   
// export const UrlContext = createContext({
//   url: 'http://localhost:3000',
//   api: 'https://testapi.postgrad.fr',
//   front: 'http://localhost:3000'
// });